<!--
 * @Author: 张怀宇
 * @Date: 2020-07-02 13:45:14
 * @LastEditors: 张怀宇
 * @LastEditTime: 2020-07-13 14:46:22
--> 
<template>
  <div>
    <BreadCrumb class="bread" :breads="['广告管理','广告审核']"></BreadCrumb>
    <div class="wrap">
      <div class="header">
        <span class="nameFt">审核列表</span>
      </div>
    </div>
    <div class="submit-form">
      <el-form :model="search" :inline="true" size="small" label-width="80px">
        <div class="submit-form__search">
          <el-form-item label="广告名称">
            <el-input v-model="search.name"></el-input>
          </el-form-item>
        </div>
        <div class="submit-form__operate">
          <el-form-item>
            <el-button class="queryBtn" size="small" type="primary" @click="searchForm">查询</el-button>
            <el-button class="queryBtn" size="small" type="primary" @click="reset">重置</el-button>
          </el-form-item>
        </div>
      </el-form>
      <div class="table-con">
        <el-table :data="tableList" stripe>
          <el-table-column type="index" label="序号" align="center" :index="indexMethod"></el-table-column>
          <el-table-column label="广告标题" align="center" prop="title"></el-table-column>
          <el-table-column label="广告类型" align="center" prop="adv_type">
            <div slot-scope="scope">{{advType[scope.row.adv_type]}}</div>
          </el-table-column>
          <el-table-column label="广告品牌" align="center" prop="brand"></el-table-column>
          <el-table-column label="审核状态" align="center" prop="status">
            <div slot-scope="scope">{{adStatus[scope.row.status]}}</div>
          </el-table-column>
          <el-table-column label="创建时间" align="center" prop="created_at"></el-table-column>
          <el-table-column label="创建人" align="center" prop="rel_name"></el-table-column>
          <el-table-column label="操作" align="center" prop="operate">
            <div slot-scope="scope">
              <el-button size="small" type="primary" @click="apply(scope.row.id)">审核</el-button>
              <el-button size="small" type="danger" @click="remove(scope.row.id)">删除</el-button>
            </div>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import apis from "@/config/apis";
import listMixin from "@/mixins/list";
import alert from "@/plugins/alert";
export default {
  mixins: [listMixin],
  data() {
    return {
      search: {
        status: "UNDER_REVIEW"
      },
      advType: {
        VIDEO: "视频",
        IMAGE: "图片"
      },
      adStatus: {
        WAIT_REVIEW: "待审核",
        UNDER_REVIEW: "审核中",
        REVIEWED: "已审核",
        FAIL: "审核失败"
      }
    };
  },
  created() {
    this.search = Object.assign(this.search, this.$route.query);
    this.getData();
  },
  methods: {
    getData() {
      this.getTableData(apis.advert_list, "get", this.search);
    },
    reset() {
      this.search = {
        status: "UNDER_REVIEW"
      };
      this.getData();
    },
    apply(id) {
      this.$router.push({
        name: "applyAd",
        query: {
          id: id,
          operate: "apply"
        }
      });
    },
    remove(id) {
      alert.deleteAlert().then(next => {
        this.$axios.delete(apis.delete_advert + "/" + id).then(res => {
          if (res.data.code == 200) {
            this.$message({
              message: "删除成功",
              type: "success"
            });
            this.getData();
          }
        });
      });
    }
  }
};
</script>